import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { Container, Anchor } from 'Components/core';
import Hamburger from 'Components/Hamburger';
import { layout, colors } from 'Constants';
import isUrl from 'is-url';

import { ApiStore, Subscribe } from 'Store';

// Components
import HamburgerContent from './components/HamburgerContent';
import CODES from 'Root/libs/analytics/CodeDef';

const Header = styled.header`
  position: sticky;
  height: 60px;
  top: 0;
  left: 0;
  right: 0;
  padding: 0 16px;
  background: #fff;
  box-shadow: 0 0 10px 0px #aaa;
  z-index: 100;
`;

const Nav = styled.nav`
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: ${layout.maxWidth};
  width: 100%;
  height: 100%;
  margin: auto;

  .mobile {
    display: none !important;
  }

  @media screen and (max-width: ${layout.breakpoints.mobile}) {
    .mobile {
      display: flex !important;
    }

    .desktop {
      display: none !important;
    }
  }

  > * + * {
    margin-left: 16px;
  }
  .triangle {
    position: absolute;
    fill: rgba(249, 70, 45);
    top: 40%;
    margin-left: 10px;
  }
`;

const NavItem = styled.span`
  position: relative;
  color: ${colors.text};
  transition: 0.2s color;
  cursor: pointer;
  padding: 16px 0;
  font-size:16px ;
  font-weight:bold ;

  :hover {
    color: ${colors.accent};
  }

  > .dropdown {
    display: none;
  }

  :hover > .dropdown {
    display: flex;
  }
`;

const NavLink = props => (
  <Anchor {...props} underline={false}>
    <NavItem>{props.children}</NavItem>
  </Anchor>
);

const NavDropdown = styled.div`
  position: absolute;
  top: 100%;
  z-index: 10;
  display: flex;
  flex-direction: column;
  width: 350px;
  padding: 16px;
  background: ${colors.background};
  box-shadow: 0 0 10px 0px #aaa;

  > * {
    padding: 8px 4px;
  }
`;

const NavLinkLogo = styled.a.attrs(props => ({
  target: '_blank',
  href: props.to
}))``;

const NavLogo = styled.img`
  max-height:36px;
  max-width:45vw;
  height: auto;
  width:auto;
`;

// TODO: URL for Logo?
// FIXME: coBrandUrl
export default props => {
  const [hamburgerSelected, setHamburgerSelected] = useState(false);
  const [benefitsOpen, setBenefitsOpen] = useState(true);

  return (
    <Subscribe to={[ApiStore]}>
      {state => {
        return (
          <Header>
            <Nav>
              <NavLink code={CODES.HEADER_SITE_VISIT} to={'/'}>
                <NavLogo
                  src={state.brandInfo.logo}
                  alt={state.brandInfo.name}
                />
              </NavLink>
              {(state.coBrandLogoURL) && (
                <NavLogo src={state.coBrandLogoURL} alt="Co-Brand Logo" />
              )}
              <NavLink to="/" className="desktop" code={CODES.HOME_CLICK}>
                Home
              </NavLink>
              <NavItem className="desktop">
                Benefits
                <svg className="triangle" height="20" width="20">
                  <polygon points="0,0 10,10 20,0" />
                </svg>
                <NavDropdown className="dropdown">
                  {state.includeMedical && (
                    <NavLink  to="/benefits/medical">Medical Benefits</NavLink>
                  )}
                  {state.includePharmacy && (
                    <NavLink   to="/benefits/pharmacy">Pharmacy Benefits</NavLink>
                  )}
                  {state.includeDental && (
                    <NavLink   to="/benefits/dental">Dental Benefits</NavLink>
                  )}
                  {state.includeVision && (
                    <NavLink to="/benefits/vision">Vision Benefits</NavLink>
                  )}
                  {state.includeLifeDisability && (
                    <NavLink  to="/benefits/life-disability">
                      Life and Disability
                    </NavLink>
                  )}
                  {state.includeVoluntary && (
                    <NavLink  to="/benefits/voluntary">
                      Voluntary Supplemental Health Benefits
                    </NavLink>
                  )}
                  <NavLink   to="/benefits/how-plan-works">
                  Understanding Healthcare Terms
                  </NavLink>
                  {state.includeMoreEnrollmentMaterials && (
                    <NavLink   to="/benefits/more-materials">
                    More Enrollment Materials
                    </NavLink>
                  )}
                  {state.includeBenefitDetails && (
                    <NavLink  to="/benefits/benefit-details">
                    Benefit Details
                    </NavLink>
                  )} 
                  {state.vaInOut && (
                    <NavLink  to="/benefits/vaInOut">
                    The Ins and Outs of Coverage
                    </NavLink>
                  )} 

                </NavDropdown>
              </NavItem>
              <NavLink  className="desktop" to="/where-to-get-care">
                Where To Get Care
              </NavLink>
              <NavLink className="desktop" to="/wellness-resources">
                Wellness Resources
              </NavLink>
              <NavItem
                className="mobile"
                onClickCapture={() => setHamburgerSelected(!hamburgerSelected)}
                style={{padding: '24px 12px'}}
              >
                <Hamburger selected={hamburgerSelected} />
              </NavItem>

              <HamburgerContent
                state={state}
                style={{ display: hamburgerSelected ? undefined : 'none' }}
                className="mobile"
                closeHamburger={() => setHamburgerSelected(false)}
              />
            </Nav>
          </Header>
        );
      }}
    </Subscribe>
  );
};
